import axios from 'axios';
import { getSupabase } from './supabase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Legacy key — retained only so any old Google-OAuth token in the browser gets
// nuked on the first 401. Nothing writes to this anymore.
export const TOKEN_KEY = 'magnidrop_token';

/**
 * Request interceptor: attaches the live Supabase access token (if any) on
 * every /api/* call. We always fetch fresh from the client so Supabase's
 * built-in autoRefreshToken loop is honored.
 */
api.interceptors.request.use(async (config) => {
    try {
        const sb = getSupabase();
        if (sb) {
            const { data } = await sb.auth.getSession();
            const token = data?.session?.access_token;
            if (token) config.headers.Authorization = `Bearer ${token}`;
        }
    } catch (_) { /* offline or supabase unconfigured — request goes anon */ }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || '';
        if (status === 401 && !url.includes('/auth/')) {
            try { localStorage.removeItem(TOKEN_KEY); } catch (_) { /* ignore */ }
        }
        return Promise.reject(error);
    },
);
